import { useUIStore } from "../store/uiStore";
import { Button } from "./Button";
import { Modal } from "./Modal";

export function LockedActionPrompt() {
  const message = useUIStore((s) => s.lockedActionPrompt);
  const clearLockedActionPrompt = useUIStore((s) => s.clearLockedActionPrompt);

  return (
    <Modal
      open={message != null}
      title="Scheduled POI locked"
      icon="lock"
      onClose={clearLockedActionPrompt}
    >
      <div className="flex flex-col gap-4">
        <p className="text-sm text-secondary">
          {message ??
            "Unlock this scheduled POI before changing its day or time."}
        </p>
        <div className="flex justify-end">
          <Button onClick={clearLockedActionPrompt} variant="primary">
            OK
          </Button>
        </div>
      </div>
    </Modal>
  );
}
